//hooks
import { useState, useEffect } from 'react';
import { useApi } from '../hooks/useApi';

//component
import SignUp from './SignUp';

//mui icon
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';

//mui
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import ReplayIcon from '@mui/icons-material/Replay';

//api
import { GetSettings } from '../api/setting/GetSettings';

//type
import { settingsTypeRes } from '../api/setting/type/SettingsType';

//translate
import { useTranslation } from 'react-i18next';
import i18n from '../translate/i18n';

const params  = [
    "hotel.en_address",
    "hotel.ar_address",
    "hotel.phone",
    "hotel.email",
]

const ContactSection = () => {
    const { t } = useTranslation();
    const [contactSection, setContactSection] = useState<settingsTypeRes[]>([]);
    const {
        loading: contactLoading,
        error: contactError,
        HandlerApi: contactApi
    } = useApi(GetSettings, "GET");

    useEffect(() => {
        const fetchData = async () => {
        const contactData = await contactApi(params);
        setContactSection(contactData.data);
        };
        fetchData();
        }, []);

    const otherLangKeyPrefix = i18n.language === 'ar' ? 'hotel.ar_' : 'hotel.en_';
    const filteredContactContent = contactSection?.filter(item => {
        const key = item.key;
        const isCurrentLangContent = key.startsWith(otherLangKeyPrefix);
        const isGenericOrCurrent = !key.startsWith(otherLangKeyPrefix);
        return isCurrentLangContent || (isGenericOrCurrent && !key.includes('_address'));
    });

    return (
    <>
        <Box sx={{padding: {md: "40px", xs: "20px"}}} className={`${i18n.language === "en" ? "font-palab" : "font-helvetica-arabic-bold"} max-w-[1560px] m-auto gap-[10px]`}>
            <h2 className="sm:text-5xl max-sm:text-2xl mb-4 text-center text-white">
            {t("Contact")} <span className="text-secondaryColor">{t("us")}</span>
            </h2>
            <p className="max-w-[600px] mb-10 m-auto text-center text-[#D7D6AC]">{t("contact_description")}</p>
            {contactLoading 
            ? 
            <div className='flex justify-center w-full'>
                <CircularProgress className='!text-white'/>
            </div>
            :
            contactError
            ?
            <div className='cursor-pointer flex justify-center w-full'>
                <ReplayIcon onClick={()=>contactApi(params)} className='!text-[40px] !text-white' />
            </div>
            :
            <>
                <div className="flex max-lg:block gap-10">
                    <div className="w-1/2 flex flex-col max-lg:w-full">
                        <div className='flex justify-between flex-wrap'>
                            {filteredContactContent?.map((element, index) => {
                                if (element.key === "hotel.ar_address" || element.key === "hotel.en_address") {
                                    return(
                                        <div key={index} className="flex gap-2 mb-10">
                                            <LocationOnOutlinedIcon className="text-secondaryColor"/>
                                            <div>
                                                <p className="text-white text-xl">{t("address")}</p>
                                                {element.value.split("_").map((element, index) => (
                                                    <p className="text-[#D7D6AC] text-sm" key={index}>{element}</p>
                                                ))}
                                            </div>
                                        </div>
                                    )
                                }
                                else if (element.key === "hotel.phone") {
                                    return (
                                        <div key={index}  className="flex gap-2 mb-10">
                                            <PhoneOutlinedIcon className="text-secondaryColor"/>
                                            <div>
                                            <p className="text-white text-xl">{t("phone")}</p>
                                            <p className="text-[#D7D6AC] text-sm">
                                                <a style={{direction: "ltr", unicodeBidi: "embed"}}  href={`tel:${element.value}`}>
                                                    {element.value}
                                                </a>
                                            </p>
                                            </div>
                                        </div>
                                    )
                                }
                                else {
                                    return (
                                        <div key={index}  className="flex gap-2 mb-10">
                                            <EmailOutlinedIcon className="text-secondaryColor"/>
                                            <div>
                                            <p className="text-white text-xl">{t("email")}</p>
                                            <p className="text-[#D7D6AC] text-sm break-words">
                                                <a href={`mailto:${element.value}`}>
                                                    {element.value}
                                                </a>
                                            </p>
                                            </div>
                                        </div>
                                    )
                                }
                            })}
                        </div>
                        <iframe 
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3326.406318414774!2d36.29082497630038!3d33.51682004581138!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1518e731af5a6aff%3A0x6493a0bf6d4ca5bf!2sCham%20Palace%20Hotel!5e0!3m2!1sen!2sjp!4v1758529829590!5m2!1sen!2sjp" 
                        title='chamHotelMap'
                        width="100%" 
                        height="100%"
                        className="flex-1 rounded-[10px] max-lg:mb-10"
                        ></iframe>
                    </div>
                    <SignUp/>
                </div>
            </>
            }
        </Box>
        <div className="w-full h-[2px] bg-[#A19B68]"></div>
    </>
    )
}

export default ContactSection
